var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.flagOrientation)?_c('div',[_c('v-app',[_c('v-main',[_c('router-view')],1)],1)],1):_vm._e(),(!_vm.flagOrientation)?_c('NotLandskape',{attrs:{"h1":"Поверните устройство","p":"На мобильных устройствах приложение работает только в вертикальной ориентации."}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }